'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _reduxForm = require('redux-form');
var _reactRedux = require('react-redux');
var _ramda = require('ramda');
var _reduxPagan = require('redux-pagan');
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reactModal = require('react-modal');var _reactModal2 = _interopRequireDefault(_reactModal);
var _reduxFormValidators = require('../../helpers/reduxFormValidators');








var _constants = require('../../constants');





var _checkers = require('../../utils/checkers');
var _findAncestor = require('../../helpers/findAncestor');var _findAncestor2 = _interopRequireDefault(_findAncestor);
var _appendLocale = require('../../helpers/appendLocale');var _appendLocale2 = _interopRequireDefault(_appendLocale);

var _DetailsToInvoiceVRPhoto = require('./DetailsToInvoiceVRPhoto.scss');var styles = _interopRequireWildcard(_DetailsToInvoiceVRPhoto);
var _RealtorField = require('../../components/Realtor/RealtorContactUs/RealtorField/RealtorField');var _RealtorField2 = _interopRequireDefault(_RealtorField);
var _SocialNetworkAuthentication = require('../../components/UserAuthentication/SocialNetworkAuthentication/SocialNetworkAuthentication');var _SocialNetworkAuthentication2 = _interopRequireDefault(_SocialNetworkAuthentication);

var _OMCheckbox = require('../../components/OMComponents/OMCheckbox/OMCheckbox');var _OMCheckbox2 = _interopRequireDefault(_OMCheckbox);
var _DetailsToInvoiceInputField = require('../DetailsToInvoiceForm/DetailsToInvoiceInputField');var _DetailsToInvoiceInputField2 = _interopRequireDefault(_DetailsToInvoiceInputField);
var _packagesData = require('../../packagesData');
var _paymentCalculation = require('../../helpers/paymentCalculation');
var _components = require('../../components');function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _objectWithoutProperties(obj, keys) {var target = {};for (var i in obj) {if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];}return target;}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var


DetailsToInvoiceVRPhoto = function (_Component) {_inherits(DetailsToInvoiceVRPhoto, _Component);function DetailsToInvoiceVRPhoto() {var _temp, _this, _ret;_classCallCheck(this, DetailsToInvoiceVRPhoto);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      tab: _constants.userAuthenticationTabs.SIGN_IN,
      isTemporaryEmail: false,
      showTemporaryModal: false,
      submitError: null,
      searchName: '',
      authThroughSocialNetwork: false,
      showPreloader: false }, _this.

























































    getSubmitButtonText = function (isLoggedIn) {
      var translate = _this.props.rootTranslate('saveSearchLocation');

      if (isLoggedIn) {
        return translate('submitForm')();
      }

      var actionType = _this.state.tab === _constants.userAuthenticationTabs.NEW_ACCOUNT ?
      'createNewAccount' :
      'login';

      return translate(actionType);
    }, _this.


    isLoggedIn = _this.props.isLoggedIn, _this.
    formId = 'details-to-invoice-vr-photo-form', _this.

    authThroughSocialNetwork = function (network) {
      _this.setState({ authThroughSocialNetwork: true });
      _this.props.socialNetworkAuthentication(network);
    }, _this.

    forgotPasswordClick = function (evt) {
      evt.preventDefault();
      _this.props.
      close().
      then(function () {return _this.props.openAuthenticationModal({ bodyType: _constants.authenticationModalType.FORGOT_PASSWORD });});
    }, _this.

    sendPayment = function (invoiceData) {var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
      var companyId = (0, _get2.default)(props, 'userAuthentication.data.agent_data.agency_id');
      var userId = (0, _get2.default)(props, 'userAuthentication.data.id');var _ref =
      props.selectedPackageData || {},count = _ref.count,price = _ref.price;

      window.hideMessageModal = props.hideIframeModal;
      window.successPayment = props.successPayment;
      window.failPayment = props.failPayment;
      window.isDesktop = !props.isMobile;

      return props.sendPaymentRequest({
        data: {
          products: [{ name: 'vr_photo', amount: count, until: new Date().toISOString() }],
          invoice_name: invoiceData.invoice_name,
          tax_id: invoiceData.tax_card,
          currency: _packagesData.currency.ILS,
          user_id: userId,
          locale: props.locale,
          payments_number: 1,
          amount: (0, _paymentCalculation.calculatePriceWithVAT)(price) },

        token: props.userToken });

    }, _this.

    handleSubmit = function (formData) {var
      emailField = formData.email,password = formData.password,actualEmail = formData.actualEmail,phone_number = formData.phone_number,rest = _objectWithoutProperties(formData, ['email', 'password', 'actualEmail', 'phone_number']);
      var invoiceData = Object.assign({ phone_number: phone_number }, rest);

      _this.props.saveInvoiceData(invoiceData);
      _this.setState({ invoiceData: invoiceData, showPreloader: true });

      if (_this.isLoggedIn) {
        return _this.sendPayment(invoiceData);
      }var

      showTemporaryModal = _this.state.showTemporaryModal;
      var userEmail = actualEmail || emailField;
      var action = showTemporaryModal ? _this.props.editUserProfile : _this.props.auth;

      var agentParams = rest.is_agent ? rest : {};

      var params = showTemporaryModal ? {
        userToken: _this.props.userToken,
        partialUpdate: {
          email: actualEmail } } : Object.assign({

        email: userEmail, password: password, requestType: _this.state.tab }, agentParams);

      return action(params);
    }, _this.

    resetFormError = function () {return _this.setState({ submitError: null });}, _this.

    toggleTab = function (tab) {return function (evt) {
        evt.preventDefault();
        _this.setState({ tab: tab, submitError: null });
      };}, _this.

    temporaryUserCheck = function (_ref2) {var target = _ref2.target;
      if ((0, _checkers.isTemporaryEmail)(target.value)) {
        _this.setState({ isTemporaryEmail: true });
      }
    }, _this.

    storeSearchName = function (_ref3) {var target = _ref3.target;return _this.setState({ searchName: target.value });}, _this.

    openTempMailModal = function () {
      _this.modalPortal = (0, _findAncestor2.default)(_this.formElement, 'ReactModalPortal');
      _this.modalPortal.style.display = 'none';
      _this.setState({ showTemporaryModal: true, submitError: null });
    }, _this.

    renderTabSwitcher = function () {
      if (_this.isLoggedIn) {
        return null;
      }

      switch (_this.state.tab) {
        case _constants.userAuthenticationTabs.NEW_ACCOUNT:{
            return (
              _react2.default.createElement('div', { className: styles.tabSwitcher },
                _react2.default.createElement('span', null),

                _react2.default.createElement('a', { href: '', onClick: _this.toggleTab(_constants.userAuthenticationTabs.SIGN_IN) },
                  _this.props.rootTranslate('saveSearchLocation', 'alreadyHaveAccount')),


                _react2.default.createElement('span', null)));


          }
        case _constants.userAuthenticationTabs.SIGN_IN:
        default:{
            return (
              _react2.default.createElement('div', { className: styles.tabSwitcher },
                _react2.default.createElement('a', { onClick: _this.forgotPasswordClick },
                  _this.props.rootTranslate('saveSearchLocation', 'forgotPassword')),


                _react2.default.createElement('a', { href: '', onClick: _this.toggleTab(_constants.userAuthenticationTabs.NEW_ACCOUNT) },
                  _this.props.rootTranslate('saveSearchLocation', 'newAccount'))));



          }}

    }, _this.

    renderTermsAndCondition = function () {
      if (_this.isLoggedIn || !_this.isLoggedIn && _this.state.tab !== _constants.userAuthenticationTabs.NEW_ACCOUNT) {
        return null;
      }
      var translate = _this.props.rootTranslate('saveSearchLocation');
      var delimiter = translate('delimiter')() &&
      _react2.default.createElement('span', { className: !translate('delimiter')() ? styles.delimiter : '' },
        translate('delimiter'));



      return (
        _react2.default.createElement('div', { className: styles.termsAndCondition },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'term_of_use',
            id: 'term_of_use',
            type: 'checkbox',
            component: function component(_ref4) {var _cx;var id = _ref4.id,input = _ref4.input,meta = _ref4.meta;return (
                _react2.default.createElement(_OMCheckbox2.default, {
                  id: id,
                  field: input,
                  className: (0, _classnames2.default)(styles.checkbox, (_cx = {}, _cx[styles.invalid] = meta.error && !meta.active && meta.submitFailed, _cx)) }));},


            validate: [_reduxFormValidators.required] }),


          _react2.default.createElement('p', { className: styles.checkboxLabel },

            _react2.default.createElement('span', null, translate('confirm')), ' ', _react2.default.createElement('a', { href: (0, _appendLocale2.default)(_this.props.locale, '/terms'), target: '_blank', rel: 'noopener noreferrer' },
              translate('termsOfUse')), ' ',
            delimiter, ' ', _react2.default.createElement('a', { href: (0, _appendLocale2.default)(_this.props.locale, '/privacy'), target: '_blank', rel: 'noopener noreferrer' },
              translate('privacy')))));




    }, _this.

    renderIsAgentCheckbox = function () {
      if (_this.isLoggedIn || !_this.isLoggedIn && _this.state.tab !== _constants.userAuthenticationTabs.NEW_ACCOUNT) {
        return null;
      }
      var translate = _this.props.rootTranslate('saveSearchLocation');

      return (
        _react2.default.createElement('div', { className: styles.termsAndCondition },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'is_agent',
            id: 'is_agent',
            type: 'checkbox',
            component: function component(_ref5) {var _cx2;var id = _ref5.id,input = _ref5.input,meta = _ref5.meta;return (
                _react2.default.createElement(_OMCheckbox2.default, {
                  id: id,
                  field: input,
                  className: (0, _classnames2.default)(styles.checkbox, (_cx2 = {}, _cx2[styles.invalid] = meta.error && !meta.active && meta.submitFailed, _cx2)) }));} }),




          _react2.default.createElement('p', { className: styles.checkboxLabel },
            translate('professionalConfirmation'))));



    }, _this.

    renderAgentDetails = function () {
      if (_this.state.tab !== _constants.userAuthenticationTabs.NEW_ACCOUNT || !_this.props.fields.is_agent) {return null;}
      var translate = _this.props.rootTranslate('saveSearchLocation');

      return (
        _react2.default.createElement('div', { className: styles.agentDataRow },
          _react2.default.createElement(_reduxForm.Field, {
            name: 'license_number',
            id: 'license_number',
            type: 'text',
            htmlFor: 'license_number',
            component: _RealtorField2.default,
            placeholder: translate('licenseNumber')(),
            validate: [_reduxFormValidators.licenseNumber],
            translate: _this.props.rootTranslate,
            translateForError: _this.props.rootTranslate('errorFieldMessages'),
            isRtl: _this.props.isRtl,
            isMobile: _this.props.isMobile,
            className: styles.saveSearchInputContainer,
            onFocus: _this.resetFormError }),


          _react2.default.createElement(_reduxForm.Field, {
            name: 'company_name',
            id: 'company_name',
            type: 'text',
            htmlFor: 'company_name',
            component: _RealtorField2.default,
            placeholder: translate('companyName')(),
            validate: [_reduxFormValidators.required],
            translate: _this.props.rootTranslate,
            translateForError: _this.props.rootTranslate('errorFieldMessages'),
            isRtl: _this.props.isRtl,
            isMobile: _this.props.isMobile,
            className: styles.saveSearchInputContainer,
            onFocus: _this.resetFormError }),

          _react2.default.createElement('div', null)));


    }, _this.

    renderTopBlock = function () {var _this$props =
      _this.props,selectedPackageData = _this$props.selectedPackageData,purchaseTranslate = _this$props.purchaseTranslate,translate = _this$props.translate;
      var packageData = selectedPackageData || {};var _packageData$price =
      packageData.price,price = _packageData$price === undefined ? 0 : _packageData$price,count = packageData.count,id = packageData.id;
      var priceGrand = (0, _paymentCalculation.calculatePriceWithVAT)(price);
      var postfix = count > 1 ? 's' : '';

      var objectsCount = _this.props.locale === _constants.language.default ?
      translate('packageName' + id) :
      count + ' ' + purchaseTranslate('photo' + postfix);

      return (
        _react2.default.createElement('div', { className: styles.topBlock },
          _react2.default.createElement('h2', { className: styles.title }, purchaseTranslate('purchaseSummary')),
          _react2.default.createElement('div', { className: styles.totalBlock },
            _react2.default.createElement('div', null, purchaseTranslate('advertisingForVR'), '\xA0', objectsCount),
            _react2.default.createElement('div', null,
              purchaseTranslate('totalInclude'), '\u20AA', priceGrand))));




    }, _this.

    renderIdField = function () {var _this$props2 =
      _this.props,purchaseTranslate = _this$props2.purchaseTranslate,userAuthentication = _this$props2.userAuthentication,fields = _this$props2.fields;
      var isAgent = (0, _get2.default)(userAuthentication, 'data.is_agent') || fields.is_agent;

      var validateFunc = isAgent ? _reduxFormValidators.required : _reduxFormValidators.israelCardholderId;
      var translationPrefix = isAgent ? 'companyId' : 'id';

      return (
        _react2.default.createElement(_reduxForm.Field, {
          name: 'tax_card',
          component: _DetailsToInvoiceInputField2.default,
          errorMsg: '' + purchaseTranslate(translationPrefix + 'ErrorMessage'),
          iconName: 'id-card',
          validate: [validateFunc],
          placeholder: purchaseTranslate(translationPrefix).toString() }));


    }, _this.

    renderPhoneNumberField = function () {var
      purchaseTranslate = _this.props.purchaseTranslate;

      return (
        _react2.default.createElement(_reduxForm.Field, {
          name: 'phone_number',
          iconName: 'contacts-phone',
          component: _DetailsToInvoiceInputField2.default,
          errorMsg: '' + purchaseTranslate('phoneErrorMessage'),
          type: 'tel',
          normalize: function normalize(value) {return value.replace(/[\D]/g, '');},
          placeholder: purchaseTranslate('phone').toString(),
          validate: [_reduxFormValidators.required, _reduxFormValidators.phoneNumber],
          isRtl: _this.props.isRtl }));


    }, _this.

    renderSubmitButton = function (submitting) {return (
        _react2.default.createElement('button', { className: styles.submitButton, type: 'submit' },
          submitting &&
          _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }),


          !submitting && _this.getSubmitButtonText()));}, _this.



    renderAuthMessage = function () {
      var translate = _this.props.rootTranslate('saveSearchLocation');

      var login = _react2.default.createElement('a', { href: '', onClick: _this.toggleTab(_constants.userAuthenticationTabs.SIGN_IN) }, translate('loginText'));
      var register = _react2.default.createElement('a', { href: '', onClick: _this.toggleTab(_constants.userAuthenticationTabs.NEW_ACCOUNT) }, translate('registerText'));

      return (
        _react2.default.createElement('div', null,
          translate('pleaseVR'), '\xA0', login, '\xA0', translate('or'), '\xA0', register));


    }, _temp), _possibleConstructorReturn(_this, _ret);}DetailsToInvoiceVRPhoto.prototype.componentWillMount = function componentWillMount() {if (__CLIENT__) {document.body.style.overflow = 'hidden';}this.minLengthValidator = (0, _reduxFormValidators.minLength)(6, 'password');this.maxLengthValidator = (0, _reduxFormValidators.maxLength)(20, 'password');};DetailsToInvoiceVRPhoto.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref6) {var userAuthenticationError = _ref6.userAuthenticationError,submitting = _ref6.submitting,isLoggedIn = _ref6.isLoggedIn,payments = _ref6.payments,rest = _objectWithoutProperties(_ref6, ['userAuthenticationError', 'submitting', 'isLoggedIn', 'payments']);var newProps = Object.assign({ userAuthenticationError: userAuthenticationError, submitting: submitting, isLoggedIn: isLoggedIn, payments: payments }, rest);var userAuthError = this.props.userAuthenticationError;if (payments.error && !this.props.payments.error) {this.setState({ showPreloader: false });} // Check if user authorized through social networks
    if (this.state.authThroughSocialNetwork && !this.props.isLoggedIn && isLoggedIn) {this.isLoggedIn = true;} // Auth error
    if (!userAuthError && userAuthenticationError || userAuthError && userAuthenticationError && userAuthError.name !== userAuthenticationError.name) {this.setState({ submitError: userAuthenticationError.name, showPreloader: false });return;}if (this.props.submitting && !submitting && !userAuthenticationError) {this.props.clearSubmit();if (this.state.isTemporaryEmail && !this.state.showTemporaryModal) {this.openTempMailModal();} else {this.sendPayment(this.state.invoiceData, newProps);}}};DetailsToInvoiceVRPhoto.prototype.componentWillUnmount = function componentWillUnmount() {if (document) {document.body.style.overflow = '';}if (this.modalPortal) {this.modalPortal.style.display = '';}if (this.props.onFormClose) {this.props.onFormClose();}}; // Preserve login state
  DetailsToInvoiceVRPhoto.prototype.render = function render() {var _this2 = this;var submitting = this.props.submitting;

    return (
      _react2.default.createElement('div', { className: styles.formWrapper },
        this.state.showPreloader &&
        _react2.default.createElement('div', { className: styles.preloader },
          _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' })),


        _react2.default.createElement('form', {
            onSubmit: this.props.handleSubmit(this.handleSubmit),
            className: (0, _classnames2.default)(styles.saveSearchForm, { rtl: this.props.isRtl }),
            id: this.formId,
            noValidate: true,
            ref: function ref(_ref7) {_this2.formElement = _ref7;} },

          this.renderTopBlock(),

          _react2.default.createElement(_components.OMTitle, {
            className: 'publishTitle',
            title: this.props.purchaseTranslate('detailsToInvoice') }),


          _react2.default.createElement('div', { className: styles.invoiceFields },
            _react2.default.createElement(_reduxForm.Field, {
              name: 'invoice_name',
              component: _DetailsToInvoiceInputField2.default,
              errorMsg: '' + this.props.purchaseTranslate('nameErrorMessage'),
              iconName: 'user',
              validate: [_reduxFormValidators.required],
              placeholder: this.props.purchaseTranslate('nameForInvoice').toString() }),

            this.renderIdField(),
            this.renderPhoneNumberField()),


          !this.isLoggedIn &&
          _react2.default.createElement('div', { className: styles.inputContainer },
            _react2.default.createElement('div', { className: styles.tabDescription }, this.renderAuthMessage()),

            _react2.default.createElement('div', { className: styles.authRow },
              _react2.default.createElement(_reduxForm.Field, {
                name: 'email',
                id: 'email',
                type: 'text',
                htmlFor: 'email',
                component: _RealtorField2.default,
                placeholder: this.props.rootTranslate('email')(),
                validate: [_reduxFormValidators.email],
                translate: this.props.rootTranslate,
                translateForError: this.props.rootTranslate('errorFieldMessages'),
                isRtl: this.props.isRtl,
                onChange: this.temporaryUserCheck,
                isMobile: this.props.isMobile,
                className: styles.saveSearchInputContainer,
                onFocus: this.resetFormError }),


              _react2.default.createElement(_reduxForm.Field, {
                name: 'password',
                id: 'password',
                type: 'password',
                htmlFor: 'password',
                component: _RealtorField2.default,
                placeholder: this.props.rootTranslate('password')(),
                validate: [this.minLengthValidator, this.maxLengthValidator],
                translate: this.props.rootTranslate,
                translateForError: this.props.rootTranslate('errorFieldMessages'),
                isRtl: this.props.isRtl,
                isMobile: this.props.isMobile,
                className: styles.saveSearchInputContainer,
                onFocus: this.resetFormError }),


              !this.props.isMobile && !this.props.isLoggedIn && this.renderSubmitButton(submitting)),


            this.renderAgentDetails()),



          this.props.isLoggedIn &&
          _react2.default.createElement('div', { className: styles.buttonRow },
            _react2.default.createElement('button', { className: styles.submitButton, type: 'submit' },
              submitting &&
              _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }),

              !submitting && this.getSubmitButtonText(true))),




          this.renderIsAgentCheckbox(),
          this.props.isMobile && !this.props.isLoggedIn && this.renderSubmitButton(submitting),
          this.renderTermsAndCondition(),

          (!!this.state.submitError || this.props.isMobile) &&
          _react2.default.createElement('p', { className: styles.formError },
            !!this.state.submitError &&
            this.props.rootTranslate('saveSearchLocation', 'errors', this.state.submitError)),




          !this.isLoggedIn &&
          _react2.default.createElement('div', { className: styles.bottomBlock },
            this.renderTabSwitcher(),

            _react2.default.createElement(_SocialNetworkAuthentication2.default, {
              translate: this.props.rootTranslate('userAuthentication'),
              socialNetworkAuthentication: this.authThroughSocialNetwork,
              className: styles.social,
              isMobile: this.props.isMobile })),




          _react2.default.createElement(_reactModal2.default, {
              contentLabel: 'temporary-user',
              isOpen: this.state.showTemporaryModal,
              style: Object.assign({}, _constants.centeredModalStyle, {

                overlay: Object.assign({},
                _constants.centeredModalStyle.overlay, {
                  zIndex: 15 }) }),


              shouldCloseOnOverlayClick: false,
              shouldCloseOnEsc: false },

            _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.tempUserModalBody, styles.inputContainer, { rtl: this.props.isRtl }) },
              _react2.default.createElement('div', { className: styles.controlRow },
                _react2.default.createElement('i', { className: 'icon-close', onClick: this.props.close })),


              _react2.default.createElement('h2', { className: styles.title },
                this.props.rootTranslate('userAuthentication', 'title')),


              _react2.default.createElement('label', { htmlFor: 'actualEmail' },
                this.props.rootTranslate('userAuthentication', 'descriptionForTemporaryUser')),


              _react2.default.createElement(_reduxForm.Field, {
                component: _RealtorField2.default,
                name: 'actualEmail',
                id: 'actualEmail',
                type: 'email',
                htmlFor: 'actualEmail',
                placeholder: this.props.rootTranslate('email')(),
                formId: this.formId,
                validate: [_reduxFormValidators.email, _reduxFormValidators.noTempMail],
                translate: this.props.rootTranslate,
                translateForError: this.props.rootTranslate('errorFieldMessages'),
                isRtl: this.props.isRtl,
                isMobile: this.props.isMobile,
                className: styles.saveSearchInputContainer,
                onFocus: this.resetFormError }),


              _react2.default.createElement('button', { type: 'submit', form: this.formId, className: styles.submitButton },
                submitting &&
                _react2.default.createElement('i', { className: 'icon icon-om-spinner om-pulse' }),


                !submitting && this.getSubmitButtonText()),


              (!!this.state.submitError || this.props.isMobile) &&
              _react2.default.createElement('p', { className: styles.formError },
                !!this.state.submitError &&
                this.props.rootTranslate('saveSearchLocation', 'errors', this.state.submitError)))))));








  };return DetailsToInvoiceVRPhoto;}(_react.Component);


DetailsToInvoiceVRPhoto.propTypes = {
  locale: _propTypes2.default.string,
  translate: _propTypes2.default.func,
  rootTranslate: _propTypes2.default.func,
  purchaseTranslate: _propTypes2.default.func,
  handleSubmit: _propTypes2.default.func,
  isMobile: _propTypes2.default.bool,
  isRtl: _propTypes2.default.bool,
  close: _propTypes2.default.func,
  isLoggedIn: _propTypes2.default.bool,
  fields: _propTypes2.default.object,
  socialNetworkAuthentication: _propTypes2.default.func,
  auth: _propTypes2.default.func,
  editUserProfile: _propTypes2.default.func,
  userToken: _propTypes2.default.string,
  payments: _propTypes2.default.object,
  userAuthentication: _propTypes2.default.object,
  userAuthenticationError: _propTypes2.default.object,
  selectedPackageData: _propTypes2.default.object,
  sendPaymentRequest: _propTypes2.default.func,
  submitting: _propTypes2.default.bool,
  clearSubmit: _propTypes2.default.func,
  openMessageModal: _propTypes2.default.func,
  hideMessageModal: _propTypes2.default.func,
  hideIframeModal: _propTypes2.default.func,
  successPayment: _propTypes2.default.func,
  failPayment: _propTypes2.default.func,
  saveInvoiceData: _propTypes2.default.func,
  openAuthenticationModal: _propTypes2.default.func,
  onFormClose: _propTypes2.default.func };

var selector = (0, _reduxForm.formValueSelector)('details-to-invoice-vr-photo-form');

var mapStateToProps = function mapStateToProps(state) {return {
    rootTranslate: (0, _reduxPagan.getLang)(state.lang, 'static'),
    translate: (0, _reduxPagan.getLang)(state.lang, 'VRPromotion'),
    purchaseTranslate: (0, _reduxPagan.getLang)(state.lang, 'PublishProperty', 'PurchaseSummery'),
    fields: {
      is_agent: selector(state, 'is_agent') } };};exports.default =



(0, _ramda.compose)(
(0, _reactRedux.connect)(mapStateToProps),
(0, _reduxForm.reduxForm)({
  form: 'details-to-invoice-vr-photo-form' }))(

DetailsToInvoiceVRPhoto);module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/DetailsToInvoiceVRPhoto/DetailsToInvoiceVRPhoto.js
// module id = 2934
// module chunks = 0